import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/app/[locale]/reviews/reviews.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de371382fe6e8e/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomerReviewCard"] */ "/tmp/8de371382fe6e8e/components/sections/CustomerReviewCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GuestReviewCard"] */ "/tmp/8de371382fe6e8e/components/sections/GuestReviewCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PartnerReviewsGrid"] */ "/tmp/8de371382fe6e8e/components/sections/PartnerReviewsGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewSection"] */ "/tmp/8de371382fe6e8e/components/sections/ReviewSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/components/ui/Container.module.css");
